import {Component} from '@angular/core';

@Component({
  selector: 'core-spinner',
  imports: [],
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
  host: {
    style: 'display: inline-block;'
  }
})
export class Spinner {
}
